import React from 'react';
import { FlapHeader, TabContent } from "components/layout"
import { UserAvatar } from "components/shared";
import { ClientChipHoc } from 'components/pages/client-management/client-chip';
import { ClientHistoryHoc } from 'components/pages/client-management/client-history';
import { TaskActivityHoc } from 'components/pages/tasks-page/task-activity';
import { SessionCounter } from 'components/pages/tasks-page/session-counter';


export const TasksRightSide = (props) => {

    const tabItems = [
        {
            leftIcon: "bi bi-info-circle-fill",
            header: "Session",
            content: <SessionCounter task={props.task} />
        },
        {
            leftIcon: "bi bi-person-circle",
            header: "Client",
            content: <ClientChipHoc task={props.task} taskView={props.taskView} />
        },
        {
            leftIcon: "bi bi-clock-fill",
            header: "Activity",
            content: <TaskActivityHoc task={props.task} taskView={props.taskView} />
        },
        {
            leftIcon: "bi bi-envelope-fill",
            header: "History",
            sticky: true,
            content: <ClientHistoryHoc task={props.task} taskView={props.taskView} />
        }];

    return (
        <div className="w-100">
            <FlapHeader
                primary
                leftSide={
                    <div className="my-1"> <UserAvatar icon="bi bi-person" size="small" shape="circle" /> Customer chip</div>
                }
            />
            <TabContent
                tabs={tabItems}
            />
        </div>
    );
}

